import { useCallback } from 'react';

import { useUserContext } from 'contexts';
import { useIsCompanySite } from 'hooks/useSitecoreContext';

import type { GTMEvent, GTMEventWithoutUserInfo } from './GTMEvents';

export function useGtm() {
	const { customerType } = useUserContext();
	const isCompanySite = useIsCompanySite();

	const pushToGTM = useCallback(
		(partialEvent: GTMEventWithoutUserInfo) => {
			const gtmEvent: GTMEvent = {
				...partialEvent,
				user_info: {
					user_type:
						customerType === 'Anonymous'
							? isCompanySite
								? 'B2B'
								: 'Anonymous'
							: (customerType ?? 'User_Type_Missing'),
				},
			};

			if ('ecommerce' in gtmEvent) {
				globalThis.dataLayer?.push({ ecommerce: null });
			}
			globalThis.dataLayer?.push(gtmEvent);
		},
		[customerType, isCompanySite],
	);

	return { pushToGTM };
}
